import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-vision-ksa',
  templateUrl: './edit-vision-ksa.component.html',
  styleUrls: ['./edit-vision-ksa.component.scss']
})
export class EditVisionKsaComponent implements OnInit {

    productId: string | null = null;


   product: any = {
   title: '',
   description: '',
   icon: '',


  };

  pages: any[] = []; // For dropdown of contract types
  InvestorsId: any;
  previewUrl: any = null;



constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService,
    public _translateService: TranslateService
  ) {}
    ngOnInit(): void {
    // get product id from route
    this.productId = this.route.snapshot.paramMap.get('id');

    if (this.productId) {
      this.loadProduct(this.productId);
    }

        this.getContractTypes();
        this.getInvestorsId();

  }


    // ✅ Fetch all contract types for dropdown
  getContractTypes(): void {
    this.apiService.contractsType().subscribe({
      next: (response: any) => {
        this.pages = response.data || [];
      },
      error: (error) => console.error('Failed to load contract types:', error),
    });
  }
  // ✅ Load contract data by ID
  loadProduct(id: string): void {
    this.apiService.getVisionKsaById(id).subscribe({
      next: (res: any) => {
        if (res?.data) {
          this.product = res.data;
          console.log(this.product ,'this.data R')
        }
        console.log(this.product ,'this.data R')
      },
      error: (err) => {
        console.error('Failed to load product:', err);
        // this.toastr.error('Failed to load contract details');
      },
    });
  }


 
  onFileSelected(event: any): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.product.icon = file;
      
      // عرض معاينة الصورة الجديدة
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.previewUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }
  // دالة مساعدة للتحقق من وجود صورة حالية
  hasCurrentLogo(): boolean {
    return this.product.icon && typeof this.product.icon === 'string' && !this.previewUrl;
  }
  // إزالة الصورة الحالية (الموجودة في السيرفر)
  removeCurrentLogo(): void {
    this.product.icon = null;
    this.previewUrl = null;
  }

  // إزالة الصورة الجديدة (المختارة للرفع)
  removeNewLogo(): void {
    this.product.icon = null;
    this.previewUrl = null;
    
    // إعادة تعيين حقل الـ file input
    const fileInput = document.getElementById('logoUpload') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  // Update product
getInvestorsId(){ 
  this.apiService.investors().subscribe({
    next: (response: any) => {
      // The actual array is in response.data.data
      this.InvestorsId = response.data;  

     
      console.log("InvestorsId:", this.InvestorsId);
    },
    error: (error: any) => {
      console.log(error);
    }
  }
    
  )
 }
  
    // ✅ Update contract
updateProduct(): void {
  if (!this.productId) {
    this.toastr.error(this._translateService.instant('MENU.DASHBOARD.missing_id'));
    return;
  }

  // Build FormData instead of plain JSON
  const formData = new FormData();

    if (this.product.icon instanceof File) {
    formData.append('icon', this.product.icon);
  }

formData.append('title', this.product.title);
formData.append('description', this.product.description);
// formData.append('icon', this.product.icon);


  this.apiService.editVisionsKsa(this.productId, formData).subscribe({
    next: () => {
      this.toastr.success(this._translateService.instant('MENU.DASHBOARD.updated_successfully'));
      this.router.navigate(['/vision-ksa']);
    },
    error: (err) => {
      console.error('Update failed:', err);
      if (err.error?.errors) {
        const errors = err.error.errors;
        Object.keys(errors).forEach(key => this.toastr.error(errors[key][0]));
      } else {
        this.toastr.error(this._translateService.instant('MENU.DASHBOARD.failed_to_update_status'));
      }
    },
  });
}


onPdfSelected(event: any): void {
  if (event.target.files.length > 0) {
    this.product.pdf_file = event.target.files[0];
  }
}
  // updateProductt(): void {
  //   if (!this.productId) return;

  //   if (
  //     this.product.password &&
  //     this.product.password !== this.product.password_confirmation
  //   ) {
  //     this.toastr.error('Passwords do not match');
  //     return;
  //   }

  //   const form = new FormData();
  //   form.append('name', this.product.name);
  //   form.append('email', this.product.email);
  //   form.append('mobile', this.product.mobile);

  //   if (this.product.password) {
  //     form.append('password', this.product.password);
  //     form.append('password_confirmation', this.product.password_confirmation);
  //   }

  //   if (this.product.image) {
  //     form.append('image', this.product.image);
  //   }

  //   this.apiService.editreproductions(this.productId, form).subscribe({
  //     next: () => {
  //       this.toastr.success('User updated successfully');
  //       this.router.navigate(['/users']);
  //     },
  //     error: (err) => {
  //       console.error('Update failed:', err);
  //       this.toastr.error('Failed to update user');
  //     }
  //   });
  // }

}